export default "__VITE_ASSET__D2ClOD22__"